export default __webpack_public_path__ + "static/media/turno-sede.269839ec.svg";